import { Component, OnInit } from '@angular/core';
import { TourService } from 'src/app/services/tour.service';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { LoggerService } from 'src/app/services/logger.service';
import { HttpClient } from '@angular/common/http';
import ModifyMenu from 'src/assets/json/Menu/ModifyMenu.json';
import { Dashboard } from '../../models/dashboard';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import { PCTableInputModel } from '../../models/pc-table-input-model';
import { Router } from '@angular/router';

@Component({
  selector: '.app-home.container-xxl flex-grow-1 container-p',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  constructor(
    private tourService: TourService,
    private apiService: UserApiService,
    private router: Router,
    private logger: LoggerService,

    private http: HttpClient
  ) {
    tourService.setTour(`home`);
  }

  public dataExpire?: PCTableInputModel;
  public dataNeedToBy?: PCTableInputModel;

  public dashboardData?: Dashboard;
  public loadingNotification: boolean = true;
  public pcTable: boolean = true;

  public ngOnInit(): void {
    try {
      this.loadingNotification = true;

      let url = `Account/Dashboard`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.logger.addResponseLog(url, result, `Get All`);
            if (!result.data) {
              return;
            }
            this.dataExpire = new PCTableInputModel(
              result.data.expireDate,
              [],
              true,
              1,
              '',
              ''
            );

            this.dataNeedToBy = new PCTableInputModel(
              result.data.needToBuy,
              [],
              true,
              1,
              '',
              ''
            );

            this.dashboardData = result.data;
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }
}
